module.exports = __webpack_public_path__ + "03_long_brown.97361a6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/03_long_brown.png
// module id = A23w
// module chunks = 0